module.exports = __webpack_public_path__ + "static/media/act.bee9489f.svg";